import { ItemList } from '../../orm'

class AdminCustomerMigrationList extends ItemList {
    getEntityKey() {
        return "admin/migration_customer"
    }
}

export const adminCustomerMigrationList = new AdminCustomerMigrationList("admin_customer_migration__default")
